import { Product } from 'shared/constants';

const audiConfig = {
  [Product.DETAILED_COMPARATOR]: { hasPhevTestType: true },
  [Product.USED_COMPARATOR]: { hasPhevTestType: true },
  [Product.ALL]: { showNewLegalUpdates: true },
};

export default audiConfig;
